var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 12.1667V13.8334C1.33334 14.2754 1.50894 14.6993 1.8215 15.0119C2.13406 15.3244 2.55798 15.5 3.00001 15.5H13C13.442 15.5 13.866 15.3244 14.1785 15.0119C14.4911 14.6993 14.6667 14.2754 14.6667 13.8334V12.1667M3.83334 7.16671L8.00001 11.3334M8.00001 11.3334L12.1667 7.16671M8.00001 11.3334V1.33337",
    stroke: "#969697",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b8d58cb24e5b8a317b0929074e2fa11b.svg";
export { ForwardRef as ReactComponent };